import { AuthLayout } from '@/bundle/Auth/ui/AuthLayout/AuthLayout';
import { VerifyOtpCodeForm } from '@/bundle/Auth/AdminOnboardingFlow/VerifyOtpCodePage/ui/VerifyOtpCodeForm';
import { AdminOnboardingStepper } from '../ui/AdminOnboardingStepper';
import { AuthStep } from '@/bundle/Auth/ui/AuthStep/AuthStep';
import { useMutation } from '@tanstack/react-query';
import { resendOtpCode, sendOtpCode } from './api';
import { useAuthNavigateToStep } from '../../hooks/useAuthNavigateToStep';
import { useRef } from 'react';
import { useLocation } from 'react-router';
import { useAdminOnboardingFlowFromAuthToken } from '@/bundle/shared/hooks/useAdminOnboardingFlowFromAuthToken';

export const VerifyOtpCodePage = () => {
  const navigateToStep = useAuthNavigateToStep();
  const { isOnboardingFlow, signUpStep } = useAdminOnboardingFlowFromAuthToken();

  const location = useLocation();
  const otpCodeFormRef = useRef(null);
  const email = location.state?.email || '';

  const {
    mutate: sendOtpCodeMutate,
    data: sendOtpCodeData,
    isPending: isPendingSendOtpCode,
  } = useMutation({
    mutationKey: ['send_otp_code'],
    mutationFn: (otpCode: string) => {
      return sendOtpCode(otpCode);
    },
    onSuccess(response) {
      if (response?.error) return;

      return navigateToStep(response?.body);
    },
    onSettled() {
      otpCodeFormRef?.current?.resetCodeChanged();
    },
  });

  const {
    mutate: resendOtpCodeMutate,
    data: resendOtpCodeData,
    isPending: isPendingResendOtpCode,
  } = useMutation({
    mutationKey: ['resend_otp_code'],
    mutationFn: () => {
      return resendOtpCode();
    },
    onSuccess(response) {
      const retryAfter = response?.headers?.retryAfter;

      otpCodeFormRef?.current?.resetTimer(retryAfter);

      if (response?.error) return;
    },
  });

  return (
    <AuthLayout banner={isOnboardingFlow && <AdminOnboardingStepper signUpStep={signUpStep} />}>
      <AuthStep width='508px' top={0}>
        <VerifyOtpCodeForm
          ref={otpCodeFormRef}
          email={email}
          isOtpCodeLoading={isPendingSendOtpCode}
          isResendOtpCodeLoading={isPendingResendOtpCode}
          otpCodeError={sendOtpCodeData?.error}
          resendOtpCodeError={resendOtpCodeData?.error}
          onConfirm={sendOtpCodeMutate}
          onResend={resendOtpCodeMutate}
        />
      </AuthStep>
    </AuthLayout>
  );
};
